import { render, staticRenderFns } from "./FieldType21.vue?vue&type=template&id=406726d8&scoped=true"
import script from "./FieldType21.vue?vue&type=script&lang=js"
export * from "./FieldType21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406726d8",
  null
  
)

export default component.exports